import styled from 'styled-components';

export const AppsContainer = styled.div`
  .menu-app-item {
    text-align: center;
    padding: 8px;
    margin-top: 4px;
    h1 {
      font-size: ${({ theme }) => theme.fontSizes.extraLarge};
    }
  }

  .home-app-item {
    width: 188px;
    text-align: center;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
  }

  .app-item-with-icon {
    display: flex;

    .app-item-icon {
      display: grid;
      place-items: center;
      margin-right: 8px;

      svg {
        height: 24px;
        width: 24px;
      }
    }
  }
`;

export const AppsMenuContent = styled.div`
  padding: 0 8px;
  padding-bottom: 8px;

  .selected-app {
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
    background: ${({ theme }) => theme.colors.primary};
    text-align: center;
    justify-content: center;

    span,
    h1,
    path {
      color: ${({ theme }) => theme.colors.white};
    }

    svg path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }

  .app-type {
    svg,
    img {
      max-height: 32px;
    }
  }

  .selected-app h1 span {
    color: ${({ theme }) => theme.colors.white};
  }

  .ant-divider {
    text-transform: uppercase;
    font-weight: bold;
    font-size: ${({ theme }) => theme.fontSizes.verySmall};
    color: ${({ theme }) => theme.colors.text2};
  }

  .apps-section-operations {
    margin-top: 24px;
  }
`;

export const AppsHomeContent = styled.div`
  margin: 32px 0;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;

  .ant-divider {
    color: ${({ theme }) => theme.colors.text1};
  }

  .ant-divider:first-child {
    margin-top: 0;
  }

  .app-item h1 {
    font-size: ${({ theme }) => theme.fontSizes.extraLarge};
  }

  .app-item-with-icon {
    justify-content: center;
  }
`;

export const AppItem = styled.div<{ isDarkTheme?: boolean }>`
  padding: 8px 0;
  text-align: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;

  h1 {
    color: ${({ theme }) => theme.colors.text};
    font-weight: bold;
  }

  :not(.selected-app) .app-item-icon svg path {
    fill: ${({ theme }) => theme.colors.primary};
  }

  svg path {
    fill: ${({ theme }) => theme.colors.text};
  }

  :hover {
    transform: scale(1.05);
  }
`;
